import { motion } from "framer-motion";
import { Coffee } from "lucide-react";
import { Button } from "./ui/button";

const About = () => {
  const scrollToContact = () => {
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="about" className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden">
      {/* Geometric elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute" style={{ right: '5%', top: '12%' }}>
          <div className="w-16 h-px bg-gradient-to-r from-purple-400/20 to-transparent" />
          <div className="w-px h-16 bg-gradient-to-b from-purple-400/20 to-transparent" style={{ marginTop: -1 }} />
        </div>
        <div className="absolute w-px bg-gradient-to-b from-transparent via-white/[0.06] to-transparent" style={{ height: '50%', right: '10%', top: '25%' }} />
        <div className="absolute w-2.5 h-2.5 rounded-full bg-white/[0.06]" style={{ left: '3%', top: '40%' }} />
        <div className="absolute h-px bg-gradient-to-r from-transparent via-white/[0.05] to-transparent" style={{ width: '20%', left: '5%', bottom: '15%' }} />
        <div className="absolute border border-white/[0.04]" style={{ width: 12, height: 12, right: '20%', bottom: '10%', transform: 'rotate(45deg)' }} />
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden">
              {/* Gradient border effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-violet-500/20 rounded-3xl" />
              <img
                src="https://customer-assets.emergentagent.com/job_web-creator-900/artifacts/f1i2jn64_IMG-20260207-WA0229.jpg"
                alt="Dhvanil"
                className="relative w-full aspect-square object-cover rounded-3xl"
              />
              {/* Subtle overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/30 to-transparent rounded-3xl" />
            </div>
            
            {/* Decorative elements */}
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              className="absolute -top-6 -right-6 w-24 h-24 bg-gradient-to-br from-blue-500/30 to-violet-500/30 rounded-full blur-2xl"
            />
            <motion.div
              animate={{ y: [0, 10, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 1 }}
              className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-violet-500/30 to-pink-500/30 rounded-full blur-2xl"
            />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="text-sm font-mono text-blue-400 tracking-wider uppercase mb-4">
              About me
            </p>
            
            <h2 className="text-3xl md:text-4xl font-bold font-['Syne'] text-white leading-tight mb-6">
              Hey, you made it!
            </h2>

            <p className="text-lg text-white/70 leading-relaxed mb-6">
              Well, thanks for scrolling — now, about me!
            </p>

            <p className="text-base text-white/60 leading-relaxed mb-6">
              I'm <span className="text-white font-medium">Dhvanil</span> - a designer at heart, a tech nerd by obsession, and someone who genuinely gets excited over a beautiful car. Three very different things, same reason: I'm drawn to anything that's been crafted with <span className="text-gradient font-medium">intention</span>.
            </p>

            <p className="text-base text-white/60 leading-relaxed mb-8">
              My philosophy? <span className="text-white font-medium">Design to make things simpler.</span> Life's complicated enough - good design shouldn't add to that.
            </p>

            <div className="p-6 rounded-2xl bg-white/5 border border-white/10 mb-8">
              <p className="text-white/80 italic">
                "Want to chat over a coffee? Hit me up, I won't say no to coffee. <span className="text-gradient font-semibold">Ever.</span>"
              </p>
            </div>

            <Button
              onClick={scrollToContact}
              className="h-12 px-6 rounded-full bg-white text-black font-semibold hover:bg-white/90 transition-all btn-shine"
              data-testid="about-cta-coffee"
            >
              <Coffee className="w-5 h-5 mr-2" />
              Let's grab coffee
            </Button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
